export default __webpack_public_path__ + "static/media/pr.6c89e389.svg";